import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import logComponent from '../../common/logComponent';

export default function InstagramIcon({ link, style, className }) {
  if (logComponent('InstagramIcon')) { console.debug('InstagramIcon rendered'); }

  return  (
    <a href={link} className={className} style={style} title="Instagram" target="_blank" rel="noopener noreferrer">
      <FontAwesomeIcon style={style} icon={['fab','instagram']} />
    </a>
  )
}